import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRootState} from "../../store/store";
import {IUserProfile} from "../types/IUserProfile";
import {selectIsUserAuthenticated} from "../utils/select_is_user_authenticated";

export const getUserProfileApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserProfile: builder.query<IUserProfile | null, void>({
            queryFn: async (arg, queryApi, extraOptions, baseQuery) => {
                const isAuthenticated = selectIsUserAuthenticated(queryApi.getState() as IRootState);

                // If user is not authenticated, return null
                // This is to avoid unnecessary API calls
                if (!isAuthenticated) {
                    return {data: null};
                }

                const profileResult = await baseQuery({
                    url: apiUserLink.user.info
                });

                if (profileResult.error) {
                    return {error: profileResult.error};
                }

                return {data: profileResult.data as IUserProfile};
            },
            providesTags: ["UserProfile"]
        })
    }),
    overrideExisting: false
});

export const selectUserProfile = getUserProfileApi.endpoints.getUserProfile.select();

export const {useGetUserProfileQuery, useLazyGetUserProfileQuery} = getUserProfileApi;
import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRootState} from "../../store/store";
import {IUserProfile} from "../types/IUserProfile";
import {selectIsUserAuthenticated} from "../utils/select_is_user_authenticated";

export const getUserProfileApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserProfile: builder.query<IUserProfile | null, void>({
            queryFn: async (arg, queryApi, extraOptions, baseQuery) => {
                const isAuthenticated = selectIsUserAuthenticated(queryApi.getState() as IRootState);

                // If user is not authenticated, return null
                // This is to avoid unnecessary API calls
                if (!isAuthenticated) {
                    return {data: null};
                }

                const profileResult = await baseQuery({
                    url: apiUserLink.user.info
                });

                if (profileResult.error) {
                    return {error: profileResult.error};
                }

                return {data: profileResult.data as IUserProfile};
            },
            providesTags: ["UserProfile"]
        })
    }),
    overrideExisting: false
});

export const selectUserProfile = getUserProfileApi.endpoints.getUserProfile.select();

export const {useGetUserProfileQuery, useLazyGetUserProfileQuery} = getUserProfileApi;
